import FusionCharts from "fusioncharts";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";

// Initialize FusionCharts with license key
FusionCharts.options.license({
  key: process.env.FUSIONCHARTS_LICENSE_KEY,
  creditLabel: false
});

ModuleRegistry.registerModules([AllCommunityModule]);
